// extracted by mini-css-extract-plugin
export default {"phraseScore":"PhraseScore-module_phraseScore__TSnOi"};